import { useDispatch, useSelector } from "react-redux";
import { FormRegion } from "../../../../components/formregion";
import { Field } from "@progress/kendo-react-form";
import {
  FormDropDownListById,
  FormInput,
} from "../../../../forms/form-components";
import {
  databaseDDL,
  setFormValue,
} from "../../../../redux/slices/importdatasetpageslice";
import { getDataBaseType } from "../../../../lib/utils";
import i18next from "i18next";
import { useTranslation } from "react-i18next";

const ImportFromDbStep = (props) => {
  //#region state
  const { formValues } = props;
  const pageState = useSelector((state) => state.importDatasetPage);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  //#endregion

  //#region functions
  const handleOnChangeField = (id, value) => {
    dispatch(setFormValue({ id, value }));
  };

  //#endregion

  return (
    <FormRegion>
      <div className="form-group form-group-1">
        <div className="k-form-field">
          <label className="k-label k-text-disabled">{t("datasets.importdataset.selected")}</label>
          <div className="k-form-field-wrap">
            <input
              disabled={true}
              name="SelectedDataset"
              id="SelectedDataset"
              className="k-input k-input-md k-rounded-md k-input-solid"
               value={
                pageState.lst_of_datasets.find(
                  (option) =>
                    option.Id === Number(pageState.formValues.SelectedDataset)
                )?.Title
              }
            />
          </div>
        </div>
        <Field
          id={"DatabaseTypeId"}
          name={"DatabaseTypeId"}
          label={t("datasets.importdataset.datatype")}
          component={FormDropDownListById}
          data={databaseDDL}
          dataItemKey="Id"
          textField="Title"
          onChange={(e) => {
            handleOnChangeField("DatabaseTypeId", e.value);
            handleOnChangeField("DatabaseType", getDataBaseType(e.value));
          }}
        />
        <Field
          id={"Server"}
          name={"Server"}
          label={t("datasets.importdataset.server")}
          component={FormInput}
          type={"text"}
          onChange={(e) => handleOnChangeField("Server", e.value)}
        />
        <Field
          id={"Database"}
          name={"Database"}
          label={t("datasets.importdataset.database")}
          component={FormInput}
          type={"text"}
          onChange={(e) => handleOnChangeField("Database", e.value)}
        />
        <Field
          id={"Username"}
          name={"Username"}
          label={t("datasets.importdataset.username")}
          component={FormInput}
          type={"text"}
          onChange={(e) => handleOnChangeField("Username", e.value)}
        />
        <Field
          id={"Password"}
          name={"Password"}
          label={t("datasets.importdataset.password")}
          component={FormInput}
          type={"password"}
          onChange={(e) => handleOnChangeField("Password", e.value)}
        />
      </div>
    </FormRegion>
  );
};

export default ImportFromDbStep;
